import { Select } from "@mui/material"
import { KeyboardArrowDown } from "@mui/icons-material"
import { SelectChangeEvent } from "@mui/material"

type SelectFieldProps = {
  id: string
  label: string
  value: string
  onChange: (e: SelectChangeEvent) => void
  children: React.ReactNode
}

export const SelectField = ({
  id,
  label,
  value,
  onChange,
  children,
  ...props
}: SelectFieldProps) => {
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="block text-sm font-semibold text-gray-700">
        {label}
      </label>
      <Select
        id={id}
        value={value}
        onChange={onChange}
        fullWidth
        size="small"
        IconComponent={KeyboardArrowDown}
        sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            fontSize: "14px",
            color: "#374151",
            "& .MuiOutlinedInput-input": {
                padding: "11px 15px", // py-2.5 px-3
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e5e7eb",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#d1d5db",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#d1d5db",
                borderWidth: "1px",
            },
            "& .MuiSelect-icon": {
                color: "#9ca3af",
            },
            }}
        {...props}
      >
        {children}
      </Select>
    </div>
  )
}